import { render, staticRenderFns } from "./AlertMonitor.vue?vue&type=template&id=2ce25952&scoped=true"
import script from "./AlertMonitor.vue?vue&type=script&lang=js"
export * from "./AlertMonitor.vue?vue&type=script&lang=js"
import style0 from "./AlertMonitor.vue?vue&type=style&index=0&id=2ce25952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce25952",
  null
  
)

export default component.exports